<template>
  <div class="main_div">
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1>사용자 수정</h1>
      </div>
      <div class="contents_wrap w100">
        <div class="small_title_wrap">
          <h2>사용자 정보</h2>
        </div>
        <ul class="filter_list">
          <li>
            <dd>
            <label>ID<span class="forg">*</span></label>
            <ul>
              <li>
                {{ userInfo.userId }}
              </li>
            </ul>
            </dd>
          <dd>
            <label>성명<span class="forg">*</span></label>
            <ul>
              <li>
                <kendo-maskedtextbox
                    :class="{'error' : errorTarget === 'userNm'}"
                    ref="userNmRef"
                    v-model.trim="userInfo.userNm"
                    :style="'width: 100%;'"
                    maxlength="20"
                    :placeholder="'사용자명을 입력하세요.'">
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
          </li>
          <li>
            <dd>
              <label>소속 회사<span class="forg">*</span></label>
              <ul>
                <li>
<!--                  <multi-dropdown-company-->
<!--                      :class="{'error' : errorTarget === 'cmpyId'}"-->
<!--                      ref="companyMultiDropdownRef"-->
<!--                  >-->
<!--                  </multi-dropdown-company>-->
                  {{ userInfo.cmpyNm }}
                </li>
              </ul>
            </dd>
            <dd>
              <label>권한<span class="forg">*</span></label>
              <ul class="w80">
                <li>
                  {{ userInfo.authNm }}
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>
                사업장/거점<span v-if="userInfo.authId !== '9999'" class="forg">*</span>
              </label>
              <ul class="w50">
                <li>
                  <div class="box_flex">
                    <kendo-dropdownlist
                        class="w50"
                        :class="{'error' : errorTarget === 'facilityId'}"
                        ref="facilityRef"
                        v-model="userInfo.facilityId"
                        :option-label="'사업장을 선택해주세요.'"
                        :data-source="zone1DepthListForAll"
                        :data-text-field="'cdNm'"
                        :data-value-field="'cdId'"
                        @change="onChangeFacility()"
                    >
                    </kendo-dropdownlist>
                    <kendo-dropdownlist
                        class="w50 mgl5"
                        :class="{'error' : errorTarget === 'areaId'}"
                        ref="areaRef"
                        v-model="userInfo.areaId"
                        :option-label="'사업장 선택 후 선택해주세요'"
                        :data-text-field="'cdNm'"
                        :data-value-field="'cdId'"
                        :index="0"
                    >
                    </kendo-dropdownlist>
                  </div>
                </li>
              </ul>
            </dd>
            <dd>
              <label>카드 No.<span v-if="userInfo.authId === '1001'" class="forg">*</span></label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                      :class="{'error' : errorTarget === 's1EmpNo'}"
                      ref="s1EmpNoRef"
                      v-model="userInfo.s1EmpNo"
                      :style="'width: 100%;'"
                      maxlength="20"
                      :placeholder="'카드 No.를 입력하세요.'"
                      :disabled="userInfo.authId !== '1001'"
                  >
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>휴대전화번호<span class="forg">*</span></label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                      ref="spTelNoRef"
                      v-model="userInfo.spTelNo"
                      :class="{'error' : errorTarget === 'spTelNo'}"
                      mask="000-0000-0000"
                      :style="'width: 100%;'"
                      maxlength="20"
                      :placeholder="'휴대전화번호를 입력하세요.'">
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
            <dd>
              <label>이메일 주소<span class="forg">*</span></label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                      ref="emailRef"
                      :class="{'error' : errorTarget === 'email'}"
                      v-model.trim="userInfo.email"
                      :style="'width: 100%;'"
                      maxlength="50"
                      :placeholder="'이메일을 입력하세요.'">
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>계정 상태<span class="forg">*</span></label>
              <ul style="display: flex; justify-content:space-between;">
                <div v-for="item in userStatusList">
                  <input
                      class="k-radio"
                      type="radio"
                      ref="useYnRef"
                      name="useYnRef"
                      v-model="useYn"
                      :value="item.cdId"
                      :id="`${item.cdId}_status`"
                  >
                  <label :for="`${item.cdId}_status`" class="k-radio-label" style="width:100%">{{ item.cdNm }} </label>
                </div>
              </ul>
            </dd>
            <dd>
              <label>IP 접근 제어 설정<span class="forg">*</span></label>
              <ul>
                <li :style="{display:'flex', gap:'12px', lineHeight:'1.9', paddingTop:'6px', alignItems: (ipPolicyYn === 'Y' && allowIpList.length >= 2) ? 'flex-start' : 'center'}">
                  <span class="mr10" :class="ipPolicyYn === 'Y' ? 'org' : ''">
                    {{ ipPolicyYn }}
                  </span>
                  <span
                      v-if="ipPolicyYn === 'Y' && allowIpList.length > 0"
                      class="ip-grid">
                    <template v-for="(item, idx) in allowIpList">
                      <span :key="'ip' + idx" class="ip-addr">{{ item.ipAddress }}/{{ item.cidrPrefix }}</span>
                      <span :key="'dt' + idx" class="ip-date">{{ item.lastMdfyDt }}</span>
                    </template>
                  </span>
                  <button
                      class="mid_btn w15"
                      style="align-self:center;"
                      @click="openIpSettings">
                    설정
                  </button>
                </li>
              </ul>
            </dd>
          </li>
        </ul>
      </div>

      <!-- IP 접근 제어 설정 팝업 -->
      <ip-access-control-window
          ref="ipSettingsWindowRef"
          :ip-policy-yn="ipPolicyYn"
          :allow-ip-list="allowIpList"
          :max-ip-count="maxIpCount"
          @apply="onApplyIpSettings">
      </ip-access-control-window>

      <div class="fl button_area w100">
        <ul>
          <li class="w10">
            <button class="large_btn orange" @click="onClickUpdateUser">저장</button>
          </li>
          <li class="w10">
            <button class="large_btn" @click="onClickList">목록</button>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import EtnersCommonUtil from '@/common/etners.common.util'
import EtnersKendoGridUtil from '@/common/kendo.grid.util'
import MultiDropdownCompany from '@/components/MultiDropdownCompany'
import IpAccessControlWindow from '@/components/user/IpAccessControlWindow'
import $ from 'jquery'
import { LogisticsCodeDtlMixin, ZoneMixin } from '@/mixin/Mixin'
import EtnersLogisticsUtil from '@/common/etners.logistics.util'

export default {
  name: 'UserUpdate',
  components: {
    MultiDropdownCompany,
    IpAccessControlWindow,
  },
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  mounted () {
    const vm = this
    const refs = vm.$refs

    // 계정 상태
    if(vm.userStatusList.length >= 4){
      vm.userStatusList = vm.userStatusList.splice(1) // '전체' 제거
    }

    // 사용자 상세정보
    const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/user/getUserDetail.json`
    const param = {
      loginUserToken: vm.loginUserToken,
      unqUserNo: vm.unqUserNo
    }
    ApiUtil.post(url, param).then(response => {
      if(response.data === undefined || response.data.resultStatus === undefined){
        kendo.alert('정상적으로 처리되지 않았습니다.')
        return false
      }

      if (response.data.resultStatus.messageCode !== '2000') {
        kendo.alert(response.data.resultStatus.messageText)
        return false
      }
      vm.userInfo = response.data.resultData
      vm.ipPolicyYn = response.data.resultData.ipPolicyYn || 'N'
      vm.allowIpList = response.data.resultData.allowIpList || []

      // refs.companyMultiDropdownRef.$refs.cmpyNmRef.kendoWidget().value([ vm.userInfo.cmpyId ])
      refs.facilityRef.kendoWidget().value([ vm.userInfo.facilityId ])
      refs.areaRef.kendoWidget().value([ vm.userInfo.areaId ])
      vm.onChangeFacility()

      vm.useYn = vm.userInfo.useYnId
    })
  },

  methods: {
    // facility 에 따른 area 세팅
    onChangeFacility() {
      const vm = this
      vm.onChange1Depth('facilityRef')
      vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthListForAll)
      vm.$refs.areaRef.kendoWidget().value(vm.userInfo.area)
    },
    onClickUpdateUser () {
      const vm = this
      const refs = vm.$refs
      // const cmpyId =  vm.$refs.companyMultiDropdownRef.$refs.cmpyNmRef.kendoWidget().value()
      const facilityId = refs.facilityRef.kendoWidget().value().trim()
      const areaId = refs.areaRef.kendoWidget().value().trim()
      const authId = vm.userInfo.authId
      const userNm = vm.userInfo.userNm.trim()
      const spTelNo = vm.userInfo.spTelNo.replace(/-/gi,"").trim()
      const s1EmpNo = refs.s1EmpNoRef.kendoWidget().value().trim()
      const email = vm.userInfo.email.trim()
      const useYn = vm.useYn

      // 필수값 체크
      if(EtnersCommonUtil.isEmpty(userNm)){
        kendo.alert("사용자명을 입력해주세요.")
        vm.errorTarget = 'userNm'
        return
      }
      if(authId !== '9999' && EtnersCommonUtil.isEmpty(facilityId)){
        kendo.alert("사업장을 선택해주세요.")
        vm.errorTarget = 'facilityId'
        return
      }
      if(authId !== '9999' && EtnersCommonUtil.isEmpty(areaId)){
        kendo.alert("거점을 선택해주세요.")
        vm.errorTarget = 'areaId'
        return
      }
      if(authId === '1001' && EtnersCommonUtil.isEmpty(s1EmpNo)){
        kendo.alert("카드 No. 를 입력해주세요.")
        vm.errorTarget = 's1EmpNo'
        return
      }
      if(EtnersCommonUtil.isEmpty(spTelNo)){
        kendo.alert("휴대전화번호를 입력해주세요.")
        vm.errorTarget = 'spTelNo'
        return
      } else if (!EtnersLogisticsUtil.isTelNum(spTelNo)){
        kendo.alert("휴대전화번호를 형식에 맞게 입력해 주세요.")
        vm.errorTarget = 'spTelNo'
        return
      }
      if(EtnersCommonUtil.isEmpty(email)){
        kendo.alert("이메일을 입력해주세요.")
        vm.errorTarget = 'email'
        return
      } else if(!EtnersCommonUtil.isEmailAddr(email)){
        kendo.alert('이메일 형식을 확인해주세요.')
        vm.errorTarget = 'email'
        return
      }
      if(EtnersCommonUtil.isEmpty(useYn)){
        kendo.alert("계정 상태를 선택해주세요.")
        vm.errorTarget = null
        return
      }
      // IP 정책 적용 시 허용 IP 1개 이상 필수 (잠금 계정 방지)
      if(vm.ipPolicyYn === 'Y' && vm.allowIpList.length === 0){
        kendo.alert("IP 정책 적용 시 허용 IP를 1개 이상 등록해주세요.")
        vm.errorTarget = null
        return
      }
      // if(EtnersCommonUtil.isEmpty(cmpyId)){
      //   kendo.alert("회사를 선택해주세요.")
      //   vm.errorTarget = 'cmpyId'
      //   return
      // }
      vm.errorTarget = null

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/user/updateUser.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        unqUserNo: vm.unqUserNo,
        // cmpyId : cmpyId,
        facilityId: facilityId,
        areaId: areaId,
        authId: authId,
        userNm: userNm,
        s1EmpNo: s1EmpNo,
        spTelNo: spTelNo,
        email: email,
        useYn: useYn,
        ipPolicyYn: vm.ipPolicyYn,
        allowIpList: vm.allowIpList,
      }

      ApiUtil.post(url, param).then(response => {
        if(response.data === undefined || response.data.resultStatus === undefined){
          kendo.alert('정상적으로 처리되지 않았습니다.')
          return false
        }

        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }

        kendo.alert('수정 완료되었습니다.')
        vm.$router.push({
          name: 'UserDetail',
          params: {
            unqUserNo: vm.unqUserNo
          }
        })
     })
    },

    onClickList () {
      const vm = this
      vm.$router.push({
        name: 'UserList'
      })
    },

    openIpSettings () {
      const vm = this
      vm.$refs.ipSettingsWindowRef.open()
    },

    onApplyIpSettings (payload) {
      const vm = this
      vm.ipPolicyYn = payload.ipPolicyYn
      vm.allowIpList = payload.allowIpList
    },
  },
  data: function() {
    const vm = this
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    const unqUserNo = vm.$route.params.unqUserNo !== undefined && vm.$route.params.unqUserNo !== "" ? vm.$route.params.unqUserNo : null

    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      unqUserNo: unqUserNo,
      userInfo: {},
      useYn : '',
      errorTarget : null,
      // IP 접근 제어 설정 (계정별 정책)
      maxIpCount: 5,
      ipPolicyYn: 'N',
      allowIpList: [],
    }
  }
}
</script>

<style scoped>
.ip-grid {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 14px;
  row-gap: 2px;
}
.ip-date {
  color: #adb5bd;
}
</style>

